export default {"src":"/statics/ecommerce/_next/static/media/anniversary-MSL.2f2c8204.svg","height":15,"width":243,"blurWidth":0,"blurHeight":0};